import { useEffect } from "react";
import { useSettings } from "@/context/SettingsContext";
import { fileUrl } from "@/lib/api";

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content || "");
};

export default function SEO({ title, description }) {
  const { settings } = useSettings();
  useEffect(() => {
    const fullTitle = title ? `${title} | Ristorante Masetti` : "Ristorante Masetti · Cucina tipica bolognese dal 1961";
    document.title = fullTitle;
    const desc = description || "Storico ristorante di cucina tradizionale bolognese a Zola Predosa (BO) dal 1961. Pasta fresca fatta in casa, crescentine e grigliata alla brace.";
    let img = settings.social_image || settings.hero_image || "";
    img = img ? fileUrl(img) : "";

    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "restaurant");
    setMeta("property", "og:site_name", "Ristorante Masetti");
    if (typeof window !== "undefined") setMeta("property", "og:url", window.location.href);
    if (img) setMeta("property", "og:image", img);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    if (img) setMeta("name", "twitter:image", img);
  }, [title, description, settings]);
  return null;
}
